import React, { useEffect, useRef, useState } from "react";
import "../../styles/aboutus.css";
import { aboutUs } from "../../data/aboutUs";
import founderPhoto from "../../assets/images/aboutus/abhimanyu.jpg";

const isReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const AboutUsFounder = () => {
  const { kicker, name, role, paragraphs, closingNote } = aboutUs.founder;
  const sectionRef = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return undefined;

    if (isReducedMotion()) {
      setRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          setRevealed(true);
          observer.disconnect();
        });
      },
      { threshold: 0.08 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={`aboutus_founder ${revealed ? "is-revealed" : ""}`} ref={sectionRef}>
      <span className="aboutus_founder_glow" aria-hidden="true" />

      <div className="aboutus_founder_inner">
        <div className="aboutus_founder_content">
          <span className="aboutus_founder_kicker">{kicker}</span>
          <h2 className="aboutus_founder_name">{name}</h2>
          <span className="aboutus_founder_role">{role}</span>
          <span className="aboutus_mv_rule" />

          {paragraphs.map((paragraph, i) => (
            <p
              className="aboutus_mv_desc aboutus_founder_para"
              style={{ transitionDelay: `${0.12 + i * 0.08}s` }}
              key={paragraph}
            >
              {paragraph}
            </p>
          ))}

          <p className="aboutus_founder_closing">{closingNote}</p>
        </div>

        <div className="aboutus_founder_media">
          <span className="aboutus_founder_media_frame" aria-hidden="true" />
          <img loading="lazy" decoding="async" src={founderPhoto} alt={name} />
        </div>
      </div>
    </section>
  );
};

export default AboutUsFounder;
